<template>
    <div  v-loading="loading" element-loading-text="拼命加载中...">
      <!-- 发货单标题 -->
      <div slot="header" class="clearfix">
        <span>发货单管理</span>
      </div>
    

      <div class="common-form">发货详细</div>
      <!-- 出库商品列表 -->
      <el-table  :data="detail.order" style="width: 100%;height: 300px;overflow-y: auto;" border>
    
        <!-- 商品名称 -->
        <el-table-column prop="product_name" label="商品名称"></el-table-column>

        <!-- 商品分类 -->
        <el-table-column prop="category_name" label="商品分类" ></el-table-column>

        <!-- 商品规格 -->
        <el-table-column prop="spec_value" label="商品规格" ></el-table-column>

        <!-- 单价 -->
        <el-table-column prop="product_price" label="单价(元)" ></el-table-column>

        <!-- 总金额 -->
        <el-table-column prop="amount" label="总金额(元)" ></el-table-column>

        <!-- 库存 -->
        <el-table-column prop="act_stock" label="库存数量" ></el-table-column>

        <!-- 设置数量 -->
        <el-table-column prop="set_num" label="数量" ></el-table-column>

        <!-- 商品单位 -->
        <el-table-column prop="unit" label="单位"></el-table-column>

        <!-- 仓库信息 -->
        <el-table-column prop="warehousetext" label="仓库信息" ></el-table-column>

        <!-- 库位信息 -->
        <el-table-column prop="warehousekwtext" label="库位信息" ></el-table-column>

        <el-table-column prop="is_ck" label="是否出库" ></el-table-column>


      </el-table>
      <div class="common-form">途径点</div>
      <el-table  :data="detail.peisong" style="width: 100%" border>
  
        <!-- 仓库名称 -->
        <el-table-column prop="name" label="名称" ></el-table-column>
        <!-- 仓库地址 -->
        <el-table-column prop="address" label="地址"></el-table-column>
        <!-- 仓库经纬度 -->
        <el-table-column label="经纬度" >
          <template slot-scope="scope">
            <span>纬度: {{ scope.row.latitude }}</span><br />
            <span>经度: {{ scope.row.longitude }}</span>
          </template>
        </el-table-column>
        <!-- 仓库类型 -->
        <el-table-column prop="type" label="类型" >
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">仓库</span>
            <span v-else-if="scope.row.type === 2">门店</span>
            <span v-else-if="scope.row.type === 3">司机</span>
       
          </template>
        </el-table-column>  
        
        <el-table-column label="距离" >
          <template slot-scope="scope">
            <span>{{ scope.row.distance }}km</span><br />
     
          </template>
        </el-table-column>

        <el-table-column label="预估时长" >
          <template slot-scope="scope">
            <span>{{ scope.row.stimated }}分钟</span><br />
     
          </template>
        </el-table-column>

        <el-table-column prop="delivery_fee" label="门店配送费">
          <template slot-scope="scope">
            <span>{{ scope.row.delivery_fee }}元</span><br />
          </template>

        </el-table-column>

        <el-table-column prop="type" label="作为起点" >
          <template slot-scope="scope">
            <el-switch v-if="scope.row.type != 2" v-model="scope.row.start" active-color="#13ce66" 
            inactive-color="#ff4949"  @change="isDefaultChange(scope.row)"
            active-text="是" inactive-text="否"  :active-value="1" :inactive-value="0"></el-switch>
          </template>
        </el-table-column>   

  </el-table>


  <div class="common-form">配送详情</div>

  <el-table  :data="detail.hz" style="width: 100%" border>
    

    <el-table-column prop="all_distance" label="总距离" >
      <template slot-scope="scope">
            {{ scope.row.all_distance+'km' }}
          </template>

    </el-table-column>
    <el-table-column prop="es_stimated" label="预估时长" >
      <template slot-scope="scope">
            {{ scope.row.es_stimated+'分钟' }}
          </template>

    </el-table-column>
    <!-- <el-table-column prop="delivery_fee" label="配送费" >
      <template slot-scope="scope">
            {{ scope.row.delivery_fee+'元' }}
          </template>
    </el-table-column> -->


</el-table>

  

  <div class="common-form">选择司机（可配送的司机）</div>

    <el-table  :data="detail.driver_ll" style="width: 100%" border>
    
    <!-- 仓库名称 -->
    <el-table-column prop="name" label="司机名称" ></el-table-column>
    <!-- 仓库地址 -->
    <el-table-column prop="mobile" label="联系方式"></el-table-column>
   
    

    <el-table-column prop="type" label="选择司机" >
      <template slot-scope="scope">
        <el-switch v-model="scope.row.use" active-color="#13ce66" 
        inactive-color="#ff4949"  @change="driverChange(scope.row)"
        :active-value="1" :inactive-value="0"></el-switch>
      </template>
    </el-table-column>   

  </el-table>


    <div class="common-form">预估路线</div>

      <div id="map-container" v-if="detail.linex && detail.linex.length > 0" style="width:100%; height:600px"></div>

      <div v-else  style="font-size: 15px;text-align: center;line-height: 50px;">请选择起点</div>
  

  
      <!-- 发货单生成 -->
      <el-row>
        <el-col :span="24" class="text-center">
          <el-button  @click="getParams" >重新计算</el-button>
          <el-button type="success" @click="generateDeliveryNote" :disabled="orderDetails.length === 0">生成发货单</el-button>
        </el-col>
      </el-row>
    </div>
  </template>
  
  <script>
    import OrderApi from '@/api/order.js';
    import DdeliveryApi from '@/api/ddelivery.js';
import { create } from 'lodash';
  export default {
    data() {
      return {
        loading:false,
        orders: [], // 订单列表
        orderDetails: [  
          { product_name: '荠菜大肉包', product_attr: '味道:荠菜; ', product_price: 4,total_num:2,total_pay_price:7.2,store_name:"门店名称",
supply_name:"供应商名称",
           },
          { product_name: '荠菜大肉包',product_attr: '味道:红豆; ', product_price: 6.3,total_num:2,total_pay_price:12.60,store_name:"门店名称",
          supply_name:"供应商名称",
            }
        ], // 订单详细商品信息
        selectedOrder: null, // 当前选择的订单
        products: [], // 商品列表
        selectedProduct: null, // 选择的商品
        quantityToShip: 0, // 选择的商品数量

        detail:{
          orders:[]
        },


               //地图
      map: null,
      marker: null,
      polyline: null,
      passedPolyline: null,
      selectedDate: [],
      markerArr: [], //电池经纬度,也用于画线
      startIcon: '',
      endIcon: '',
      formInline:{
        quick:"0",
        line_id:"0",
        search1:"",
        search2:"",
        search3:"",
        search4:"",
      },
      form:{

      },
      o_flag:false,

      };
    },
    created() {
      var self  =this;
      /*获取列表*/
      self.loading = true;
      self.shil
      this.getParams();
      setTimeout(function(){
        if(self.detail.peisong){
            self.isDefaultChange(self.detail.peisong[0])
          }
          if(self.detail.peisong){
            self.isDefaultChange(self.detail.peisong[0])
          }
          self.loading = false;
      },1000)
    },
    mounted(){
     // 地图初始化代码
     const script = document.createElement('script');
      script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=16e7503e2bdb0605334458a3d3bd1f02';
      script.async = true;
      document.head.appendChild(script);
  },
    methods: {
      getParams() {
        var self = this;
        var params = this.form;
        params.order_id = this.$route.query.order_id;
        params.driver_id = this.form.driver_id?this.form.driver_id: this.$route.query.driver_id;
        OrderApi.generatedeliverynote(params
        ).then(data => {
        
          self.detail = data.data;

      

          if(!self.o_flag){
            setTimeout(() => {
            self.initMap();
          },300) 
          }
        
        })
          .catch(error => {
            self.loading = false;
          });
      },  
      isDefaultChange(row){
        this.form.id = row.id;
        this.form.type = row.type;
        this.o_flag = false;
        this.getParams();
      },
      driverChange(row){
        this.form.driver_id = row.driver_id;
        this.o_flag = true;
        this.getParams();
      },
      
      // 生成发货单
      generateDeliveryNote() {
        let self = this;

          if(self.detail.linex && self.detail.linex.length <= 0){
            self.$message.error('请先生成路线');
            return;
          }
          var xnd = 0;
          for(var i=0;i<self.detail.driver_ll.length;i++){
              if(self.detail.driver_ll[i].use == 1){
                xnd++;
              }
          }
          if(xnd <= 0){
            self.$message.error('请选择司机');
            return;
          }

        self
          .$confirm('是否生成发货单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DdeliveryApi.genDdelivery(
              {
                out_management_id: self.detail.out_management_id_arr,
                ddelivery_id:self.detail.ddelivery_id,
                driver_id:self.form.driver_id?self.form.driver_id: self.$route.query.driver_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '生成成功',
                    type: 'success'
                  });
                  this.$router.back(-1);
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },



      /*创建图表对象*/
   initMap() {
      let that = this;
      var peisong = that.detail.peisong;
        that.map = new AMap.Map("map-container", {
          resizeEnable: true,
          zoom: 7,
          center: that.detail.linex[0] //地图中心点
        });
        AMap.plugin(["AMap.ToolBar"], function() {
          //加载工具条
          var tool = new AMap.ToolBar();
          that.map.addControl(tool);
        });
        //清除地图的所有覆盖物
        that.map.clearMap();
        //电池经纬度,也用于画线
        this.markerArr = [];
        //获取数据
        this.GetBatteryHistory();
    },

    //获取轨迹数据
    GetBatteryHistory() {
      let that = this;
      //接口获得数据后转换，高德接受的数据格式为[[111.11,122.22],[111.11,123.33]]
      setTimeout(() => {
        //坐标点数组转换
        var marker = that.detail.line.info;//[[116.478935,39.997761],[116.478939,39.997825],[116.478912,39.998549],[116.478912,39.998549],[116.478998,39.998555],[116.478998,39.998555],[116.479282,39.99856],[116.479658,39.998528],[116.480151,39.998453],[116.480784,39.998302],[116.480784,39.998302],[116.481149,39.998184],[116.481573,39.997997],[116.481863,39.997846],[116.482072,39.997718],[116.482362,39.997718],[116.483633,39.998935],[116.48367,39.998968],[116.484648,39.999861]]
        marker.map(ele => {
            let tempArr = [];
            tempArr.push(ele[0]);
            tempArr.push(ele[1]);

            that.markerArr.push(tempArr);
        });
        
        that.$nextTick(() => {
          //画线
          that.playLine();
        });
     
      }, 1000);
    },
    //画线
    playLine() {
      let that = this;
      console.log('that.markerArr',that.markerArr)
      //初始化起点终点
      that.initStartEnd();
   
      that.marker = new AMap.Marker({
        map: that.map,
        //小车出初始位置
        position: that.markerArr[0],
        icon: "https://webapi.amap.com/images/car.png",
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        angle: -90
      });
      for(var i =0;i<that.detail.peisong.length;i++){
        var el_i = that.detail.peisong[i];
  
        if(el_i.type == 1){
           var ma =  new AMap.Marker({
              map: that.map,
              //小车出初始位置
              position: [el_i.longitude,el_i.latitude],
              icon: "./static/warehouse.png",
      
            });
     
          }else if(el_i.type == 2){
            var ma =  new AMap.Marker({
              map: that.map,
              //小车出初始位置
              position: [el_i.longitude,el_i.latitude],
              icon: "./static/store.png",
      
            });
  
          }

  


                  // 为标记绑定点击事件
                  ma.on('click', (function(el_i, ma) {
                  return function() {
                      // 动态创建 InfoWindow，显示该标记对应的内容
                      var infoWindow = new AMap.InfoWindow({
                          content: `<div>
                                      <strong>${el_i.name}</strong><br>
                                      地址: ${el_i.address}
                                    </div>`,
                          offset: new AMap.Pixel(0, -30) // 偏移量
                      });

                      // 打开当前标记的 InfoWindow
                      infoWindow.open(that.map, ma.getPosition());
                  };
              })(el_i, ma));  // 使用自执行函数立即捕获 el_i 和 ma


      }
  

      // 绘制轨迹
      that.polyline = new AMap.Polyline({
        map: that.map,
        path: that.markerArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 //线宽
        // strokeStyle: "solid"  //线样式
      });
      that.loading = false;
      //自适应放大
      setTimeout(() => {
        that.map.setFitView();
      }, 500);
    },
    //初始化起点终点
    initStartEnd() {
      let that = this;
      //将icon添加进marker
      let startMarker = new AMap.Marker({
        position: new AMap.LngLat(that.markerArr[0][0], that.markerArr[0][1]),
        icon: that.startIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      //将icon添加进marker
      let endMarker = new AMap.Marker({
        position: new AMap.LngLat(
          that.markerArr.pop()[0],
          that.markerArr.pop()[1]
        ),
        icon: that.endIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      // 将 markers 添加到地图
      that.map.add([startMarker, endMarker]);
    },
  },
  };
  </script>
  
  <style scoped>
  .div {
    margin: 20px;
  }
  .text-center {
    text-align: center;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/order/order/generatedeliverynote.vue